import React from "react";
import { Route, Routes } from "react-router";
import About from "../Pages/About/About";
import BookAppointment from "../Pages/BookAppointment/BookAppointment";
import ContactUs from "../Pages/ContactUs/ContactUs";
import Main from "../Pages/Home/Main";
import Memberships from "../Pages/Memberships/Memberships";
import ServiceDetails from "../Pages/Services/ServiceDetails";
import Services from "../Pages/Services/Services";
import Testimonials from "../Pages/Testimonials/Testimonials";
import Resources from "../Pages/Resources/Resources";

const Router = () => {
  return (
    <Routes>
      <Route path="/" element={<Main />}>
        <Route index element={<Main />} />
      </Route>
      <Route path="/about" element={<About />} />
      <Route path="/services" element={<Services />} />
      <Route path="/services/:id" element={<ServiceDetails />} />
      <Route path="/testimonials" element={<Testimonials />} />
      <Route path="/contactUs" element={<ContactUs />} />
      <Route path="/memberships" element={<Memberships />} />
      <Route path="/resources" element={<Resources />} />
      <Route path="/book" element={<BookAppointment />} />
      <Route path="/book/:id" element={<BookAppointment />} />
    </Routes>
  );
};

export default Router;
